import type {
  Channel,
  HouseholderCommonPage,
  HouseholderEntryPage,
} from "@/api_client";
import { HouseholderEntryForm } from "@/components/products/householder/entry/HouseholderEntryForm";
import { ProductContainer } from "@/components/shared/productContainer/ProductContainer";
import { useEntryForWebComponents } from "../hooks/useEntryForWebComponents";

type HouseholderEntryProps = {
  backendHost?: string;
  appPathPrefix?: string;
  skipCart: boolean;
  channel?: Channel;
  language?: string;
};

export default function HouseholderEntry({
  backendHost,
  appPathPrefix,
  skipCart,
  channel,
  language,
}: Readonly<HouseholderEntryProps>) {
  const {
    isLoading,
    isSubmitting,
    submitEntryHandler,
    policyHolder,
    user,
    content,
    commonContent,
  } = useEntryForWebComponents<HouseholderEntryPage, HouseholderCommonPage>({
    productType: "householder",
    backendHost,
    appPathPrefix,
    skipCart,
    channel,
    contentPageKey: "householderEntryPage",
    commonContentPageKey: "householderCommonPage",
    language,
  });

  if (isLoading) return <ProductContainer.Loader />;

  return (
    <HouseholderEntryForm
      externalIsLoading={isSubmitting}
      externalSubmitHandler={submitEntryHandler}
      externalPolicyHolder={policyHolder}
      externalUser={user}
      externalContent={content}
      externalCommonContent={commonContent}
    />
  );
}
